/**
 * A tile of a Connect workspace (I-3641) is a whole Connect in an iframe, opened
 * with `?tile=<id>`. Everything on this device that belongs to "the one open
 * document" of an app keeps a slot per tile, or two tiles of one app would
 * overwrite each other. Null outside a tile.
 */
export function connectTileId(): string | null {
  if (typeof location === "undefined") return null;
  return new URLSearchParams(location.search).get("tile") || null;
}

/** The owner key of a device cache that holds one open document per owner. */
export function tileScopedOwner(owner: string): string {
  const tile = connectTileId();
  return tile ? `${owner}:tile:${tile}` : owner;
}
